<template>
  <div class="card wrong-book-card">
    <div class="card-title">
      <div class="card-title__wrapper">
        <span>错题本</span>
        <img
          class="planet"
          src="https://vanthink.oss-cn-qingdao.aliyuncs.com/52ed650aba77cb8a785e76d8c4aef2b7.png" alt="">
      </div>
    </div>
    <div class="card-content-wrapper">
      <div class="item">
        <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/f9d35a6013f2bc164dc90bd1e2e395cc.png" alt="">
        <button class="btn btn-plain btn-circle"
          @click="start">消灭错题</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    start() {
      this.$emit('change', {
        scene: 'wrongBookDialog',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
@import "@/styles/common/breadcrumb.scss";
.wrong-book-card {
  width: max-content;
  background: #fff;
  border-radius: 24px;
  .card-title {
    background: #0EBFC1;
    .card-title__wrapper {
      .planet {
        top: -10px;
        width: 80px;
      }
    }
  }
  .card-content-wrapper {
    padding: 20px 20px 10px;
    display: flex;
    overflow: hidden;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 20px;
      img {
        height: 135px;
      }
      .btn {
        margin-top: 10px;
        padding: 5px 10px;
        font-weight: 700;
      }
    }
  }
}
</style>
